import * as React from 'react';

import "./reset-template-btn.scss";

import {Button}           from "@Common/tools/cc-integration/ui/button/button";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const ResetTemplateBtn = ({refreshTemplateModal}) => {

    return (
        <div className="reset-template-btn-7kf">
            <Button
                buttonText="Reset Template"
                xdQaName="Reset Template"
                onClick={async () => {
                    refreshTemplateModal.show();
                }}
            />
            <span style={{marginLeft: "5px"}}>
                {InformationBadge({
                    getTooltip: () => "Clicking this will reset the template to its default settings and update the listing data.",
                    xdQaName: "Reset Template",
                })}
            </span>
        </div>
    );
}